import { Link } from 'react-router'

import { Badge } from '@/components/ui/badge'
import { formatDateTime } from '@/lib/formatters'
import { type Sequence, SequenceStatus } from '@/models/sequence'
import { SequenceControls } from './SequenceControls'
import { leadSequencesPath, progress, STATUS_VARIANT, STOP_REASON_LABEL } from './sequenceStatus'

function Fact({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="flex flex-col gap-0.5">
      <dt className="text-muted-foreground text-xs">{label}</dt>
      <dd className="text-sm">{children}</dd>
    </div>
  )
}

export function SequenceSummary({ sequence }: { sequence: Sequence }) {
  const ended = sequence.status === SequenceStatus.STOPPED || sequence.status === SequenceStatus.COMPLETED

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-semibold">
            {sequence.salesLead ? (
              <Link to={leadSequencesPath(sequence.salesLead)} className="underline-offset-4 hover:underline">
                {sequence.salesLeadName}
              </Link>
            ) : (
              'No lead'
            )}
          </h1>
          <Badge variant={STATUS_VARIANT[sequence.status]}>{sequence.status}</Badge>
        </div>
        <SequenceControls sequence={sequence} />
      </div>
      <dl className="flex flex-wrap gap-x-10 gap-y-3">
        <Fact label="Steps done">{progress(sequence)}</Fact>
        <Fact label="Created by">{sequence.createdByName || '—'}</Fact>
        <Fact label="Start execution">{formatDateTime(sequence.dateExecuteStart)}</Fact>
        {sequence.startedAt && <Fact label="Started">{formatDateTime(sequence.startedAt)}</Fact>}
        {ended && sequence.stoppedAt && <Fact label="Ended">{formatDateTime(sequence.stoppedAt)}</Fact>}
        {sequence.stopReason && <Fact label="Why it ended">{STOP_REASON_LABEL[sequence.stopReason]}</Fact>}
      </dl>
    </div>
  )
}
